import { createFileRoute } from "@tanstack/react-router";
import { SettingsAdmin } from "src/pages/Settings/SettingsAdmin";

export const Route = createFileRoute("/settings/admin")({
	component: SettingsAdmin,
});
